<template>
  <span v-if="payment">
    <v-btn icon @click="dialog = true" v-if="payment">
      <v-icon v-if="createNew">add</v-icon>
      <v-icon v-else>edit</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" v-if="dialog" max-width="900px" :modal="true">
      <v-form @submit.prevent="saveItem">
        <v-card>
          <v-card-title class="headline">
            Edit Payment
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-layout wrap justify-space-around>
                <v-flex md5>
                  <v-text-field
                    prefix="$"
                    label="Payment Amount"
                    v-model="payment.paymentamount"
                    type="number"
                  />
                </v-flex>

                <v-flex md5>
                  <date-picker
                    label="Date Payment Received"
                    @input="payment.paymentreceiveddate = $event"
                    :value="formattedReceivedDate"
                  />
                </v-flex>

                <v-flex md5>
                  <lookup-select
                    lookup-name="PaymentStatus"
                    label="Status"
                    v-model="payment.paymentstatusid"
                  />
                </v-flex>

                <v-flex md5>
                  <lookup-select
                    lookup-name="FeeTypes"
                    label="Fee Type"
                    v-model="payment.feetypeid"
                  />
                </v-flex>

                <v-flex md11>
                  <v-text-field
                    label="Reference"
                    v-model="payment.paymentref"
                  />
                </v-flex>

                <v-flex md5>
                  <!-- <lb-select
                    url="financialbatches"
                    label="BatchId"
                    :filter="{
                      where: {
                        paymentdate: {
                          gt: $moment()
                            .subtract(3, 'months')
                            .toISOString()
                            .slice(0, 10)
                        }
                      },
                      order: 'batchid DESC'
                    }"
                    item-value="batchid"
                    :item-text="item => `(${item.batchid}) ${item.batchname}`"
                    v-model="payment.batchid"
                    v-if="createNew"
                  /> -->
                  <lb-select
                    :url="`financialbatches/${payment.batchid}`"
                    label="BatchId"
                    item-value="batchid"
                    :item-text="item => `${item.batchname} (${item.batchid})`"
                    v-model="payment.batchid"
                    :disabled="payment.batchid != null"
                    v-if="payment.batchid != null && !createNew"
                  />
                  <v-select
                    label="Payment Method"
                    v-model="payment.payment_method"
                    required
                    :items="['Manual', 'CC', 'A2A']"
                    v-if="createNew"
                  />
                </v-flex>

                <v-flex md5>
                  <v-text-field
                    label="Certificate ID"
                    v-model="payment.linkeditemid"
                    type="number"
                    :disabled="payment.linkeditemid != null"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <div class="">
              <span class="caption italics">
                Created: {{ payment.createdby }}
                {{ payment.datecreated | formatDate }} | Updated:
                {{ payment.updatedby }}
                {{ payment.dateupdated | formatDate }}
                <br />
                <small>
                  <em> FinancialBatchItemId: (#{{ payment.batchitemid }}) </em>
                </small>
              </span>
            </div>
            <v-spacer></v-spacer>
            <v-fade-transition transition="fade">
              <div v-if="!success && errors[0]">
                <v-icon>error</v-icon>{{ errors[0] }}
              </div>
              <v-icon v-show="success">check</v-icon>
            </v-fade-transition>
            <v-btn color=" primary" type="submit" :disabled="loading">
              <v-progress-circular indeterminate v-show="loading" />
              <span v-show="!loading">Save</span>
            </v-btn>
            <v-btn @click="dialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </span>
</template>

<script>
import moment from "moment";
// import PaymentSelect from "../payment-select";
import ScopeSelect from "../register/scopes/scope-select";
import lbSelect from "@/components/lib/lb-select";

export default {
  name: "editPaymentButton",
  data() {
    return {
      dialog: false,
      debugData: "",
      StartDateShowPicker: false,
      ExpiryDateShowPicker: false,
      linkToPaymentId: null,
      loading: false,
      errors: [],
      success: false
    };
  },
  props: {
    payment: {
      type: Object,
      required: false,
      default: function() {
        return {
          batchid: null,
          paymentamount: "00.00",
          paymentstatusid: null,
          feetypeid: null,
          paymentamount: null,
          paymentref: null,
          linkeditemid: null,
          personid: null
        };
      }
    },
    paymentid: {
      type: Number,
      required: false
    },
    personid: {
      type: [Number, String],
      required: false
    },
    createNew: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    formattedReceivedDate() {
      return this.payment.paymentreceiveddate.slice(0, 10);
    }
  },
  methods: {
    async saveItem() {
      this.loading = true;
      this.success = false;
      try {
        if (!this.createNew) {
          var result = await this.$http.patch(
            `/financialbatchitems/${this.payment.batchitemid}`,
            { personid: this.personid, ...this.payment }
          );
        } else {
          var result = await this.$http.post(
            `/financialbatchitems/`,
            this.payment
          );
        }

        if (result) {
          this.cert = { ...result.data };
          this.errors = [];
          this.success = true;
        }
      } catch (e) {
        this.handleError(e);
      }
      this.loading = false;
    },
    handleError(e) {
      this.errors.push(e.message);
    }
  },
  components: {
    "scope-select": ScopeSelect,
    "lb-select": lbSelect
  },
  created() {
    if (this.createNew) {
      this.payment.personid = this.personid;
      this.payment.paymentreceiveddate = this.$moment().toISOString();
      this.payment.payment_method = "Manual";

      // this.payment = {
      //   personid: this.personid,
      //   paymentamount: "00.00",
      //   paymentstatusid: null,
      //   feetypeid: null,
      //   paymentamount: null,
      //   paymentref: null,
      //   linkeditemid: null
      // };
    }
  }
};
</script>

<style></style>
